import { useSearchParams } from "react-router-dom"
import IssuePage from "~/components/issuePage/IssuePage"
import { useTeam } from "~/hooks/useTeam"
import { ErrorState, LoadingState } from "~/components/screens/StateScreen"
import { api } from "~/trpc/react"

export default function Page() {
	const { team, isLoading: isLoadingTeam } = useTeam()
	const utils = api.useUtils()
	const [searchParams] = useSearchParams()
	const labelId = searchParams.get("label")
	const {
		data: teamIssueData,
		isLoading: isLoadingIssues,
		error: issuesError
	} = api.issues.getTeamIssues.useQuery(
		{
			teamId: team?.id ?? "",
			filter: {
				status: { not: "Queue" },
				labelIds: labelId ? [labelId] : undefined
			}
		},
		{ enabled: !!team?.id }
	)

	api.issues.onUpdate.useSubscription(
		{ teamId: team?.id ?? "" },
		{
			enabled: !!team?.id,
			onData: () => {
				void utils.issues.getTeamIssues.invalidate()
				void utils.user.getTeams.invalidate()
			}
		}
	)

	if (isLoadingTeam || isLoadingIssues) return <LoadingState />
	if (issuesError || !teamIssueData) {
		return (
			<ErrorState
				title="Unable to load issues."
				description={issuesError?.message ?? "Team issues are unavailable."}
			/>
		)
	}

	return (
		<div className="flex h-full flex-col">
			<IssuePage teamIssueData={teamIssueData} />
		</div>
	)
}
